import React from 'react';
import PropTypes from 'prop-types';
import DestinationSvg from '../Destination/Svg';

const ImageGrid = props => {
  const { image1, image2 } = props;
  return (
    <div className="d8-c-how-it-works-grid">
      <div><DestinationSvg className="dots-svg" name="dots" fill="#35b1fb" /></div>
      <div className="decoration-square" />
      <div><img className="d8-u-radius-md" src={image1.url} alt={image1.alt} /></div>
      <div><img className="d8-u-radius-md" src={image2.url} alt={image2.alt} /></div>
    </div>
  );
};


ImageGrid.propTypes = {
  image1: PropTypes.object,
  image2: PropTypes.object
};

export default ImageGrid;
